import {Component, Input, OnInit} from '@angular/core';
import {filter, first, switchMap} from "rxjs/operators";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {Website} from "../../../website";
import * as fromStore from "../../../../../store";
import {combineLatest} from "rxjs";
import {Store} from "@ngrx/store";
import {EcommerceService} from "../../ecommerce.service";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {GoogleAnalyticsService} from "../../../../../shared/services/google-analytics/google-analytics.service";

@Component({
    selector: 'db-ecommerce-emails-list-table',
    templateUrl: './emails-list-table.component.html',
    styleUrls: ['./emails-list-table.component.scss'],
    standalone: false
})
export class EmailsListTableComponent implements OnInit {
  @Input() website: Website;
  public heads: string[] = [
    TextUtils.getText('text_email'),
    TextUtils.getText('text_contentType'),
    TextUtils.getText('text_recipients'),
    TextUtils.getText('text_actions')
  ];
  public emailsList: any;
  public enabled: boolean;
  public loading: boolean;

  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private _ecommerceService: EcommerceService,
    private _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit() {
    this._getEmailsList();
  }

  public updateEmailStatus(emailName, enabled): void {
    this._ecommerceService.updateEmailsStatus(this.website?.id, emailName, enabled)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success && response?.data) {
         this._store.dispatch(new fromStore.LoadEcommerceEmailsList({websiteId: this.website?.id}));
        }
      });
  }

  private _getEmailsList(): void {

    this._store.select(fromStore.getEcommerceEmailsListLoaded(this.website?.id))
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getEcommerceEmailsList(this.website?.id))
        ))
      )
      .subscribe(([emailsList]) => {
        this.emailsList = emailsList;
      });
  }

}
